
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
      display:block;
}

:host([site='GHS']) .hero-banner {
      background-size:cover;
}

:host([site='GHS']) .hero-banner {
      background-position:center;
}

:host([site='GHS']) .hero-banner {
      background-repeat:no-repeat;
}

:host([site='GHS']) .hero-banner {
      font-family:var(--ff-display);
}

:host([site='GHS']) .hero-banner {
      color:var(--neutral-white);
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner {
            font-size:var(--fs-lg);
            line-height:var(--lh-lg);
      }
}

:host([site='GHS']) .hero-banner .light-blue {
      color:var(--primary-blue-dark);
}

:host([site='GHS']) .hero-banner-content-section {
      display:grid;
}

:host([site='GHS']) .hero-banner-content-section {
      grid-template-columns:repeat(1, minmax(0, 1fr));
}

:host([site='GHS']) .hero-banner-content-section {
      gap:1.25rem;
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner-content-section {
            grid-template-columns:repeat(2, minmax(0, 1fr));
      }
}

:host([site='GHS']) .hero-banner.has-accordion .hero-banner-hero-image{
      order:1;
    }

@media (min-width: 1280px){
    :host([site='GHS']) .hero-banner-content-section{
      row-gap:1.5rem;
      grid-template-columns:repeat(auto-fit, minmax(540px, 1fr));
    }
  }

:host([site='GHS']) .full-height .hero-banner-background {
      display:flex;
}

:host([site='GHS']) .full-height .hero-banner-background {
      min-height:100vh;
}

:host([site='GHS']) .full-height .hero-banner-background {
      align-items:center;
}

@media (min-width: 1024px) {

      :host([site='GHS']) .full-height .hero-banner-background {
            min-height:80vh;
      }
}

:host([site='GHS']) .full-height outline-container {
      width:100%;
}

:host([site='GHS']) .hero-banner-background {
      padding-top:1.75rem;
}

:host([site='GHS']) .hero-banner-background {
      padding-bottom:1.25rem;
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner-background {
            padding-top:4rem;
            padding-bottom:4rem;
      }
}

:host([site='GHS']) .hero-banner-background.green-gradient{
  }

:host([site='GHS']) .hero-banner-background.green-gradient {
      background-image:var(--green-gradient);
}

:host([site='GHS']) .hero-banner-background.blue-gradient {
      background-image:var(--blue-gradient);
}

:host([site='GHS']) .hero-banner-background.light-blue {
      background-color:var(--tint-dark-blue);
}

:host([site='GHS']) .hero-banner-background.image-gradient {
      background-image:var(--black-vertical-gradient);
}

:host([site='GHS']) .hero-banner-background.image-gradient {
      padding-top:14rem;
}

:host([site='GHS']) .hero-banner-background.image-gradient {
      padding-bottom:6rem;
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner-background.image-gradient {
            background-image:var(--black-semi-horizontal-gradient);
      }
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner-background.image-gradient {
            padding-top:4rem;
            padding-bottom:4rem;
      }
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner-background.image-gradient {
            padding-left:1.75rem;
            padding-right:1.75rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .hero-banner-background.image-gradient {
            padding-left:6rem;
            padding-right:6rem;
      }
}

@media (min-width: 1280px) {

      :host([site='GHS']) .hero-banner-background.image-gradient {
            padding-left:8rem;
            padding-right:8rem;
      }
}

@media (min-width: 1360px) {

      :host([site='GHS']) .hero-banner-background.image-gradient {
            padding-left:10rem;
            padding-right:10rem;
      }
}

@media (min-width: 2180px) {

      :host([site='GHS']) .hero-banner-background.image-gradient {
            padding-left:20rem;
            padding-right:20rem;
      }
}

:host([site='GHS']) .hero-banner-breadcrumb {
      padding-bottom:0.75rem;
}

:host([site='GHS']) .hero-banner-hero-image {
      order:-9999;
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner-hero-image {
            order:9999;
      }
}

:host([site='GHS']) .hero-banner-eyebrow {
      position:relative;
}

:host([site='GHS']) .hero-banner-eyebrow {
      margin-bottom:0.75rem;
}

:host([site='GHS']) .hero-banner-eyebrow {
      display:inline-block;
}

:host([site='GHS']) .hero-banner-eyebrow {
      font-family:var(--ff-display);
}

:host([site='GHS']) .hero-banner-eyebrow {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='GHS']) .hero-banner-eyebrow {
      font-weight:var(--fw-medium);
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner-eyebrow {
            font-size:var(--fs-xl);
            line-height:var(--lh-xl);
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .hero-banner-eyebrow {
            font-size:var(--fs-2xl);
            line-height:var(--lh-2xl);
      }
}

:host([site='GHS']) .hero-banner-eyebrow{
    z-index:1;
  }

:host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
      position:relative;
}

:host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
      margin-bottom:1rem;
}

:host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
      overflow-wrap:break-word;
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
            overflow-wrap:normal;
            word-break:normal;
      }
}

:host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
      font-family:var(--ff-display);
}

:host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
      font-weight:var(--fw-bold);
}

:host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
      font-size:var(--fs-3xl);
      line-height:var(--lh-3xl);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
            font-size:var(--fs-h1-medium);
            line-height:var(--lh-h1-medium);
      }
}

@media (min-width: 1280px) {

      :host([site='GHS']) .hero-banner-title, :host([site='GHS']) .hero-banner-title h1 {
            font-size:var(--fs-h1);
            line-height:var(--lh-h1);
      }
}

:host([site='GHS']) .hero-banner-title,
  :host([site='GHS']) .hero-banner-title h1{
    line-height:var(--lh-h2-small);
  }

@media (min-width: 1024px){
    :host([site='GHS']) .hero-banner-title,
    :host([site='GHS']) .hero-banner-title h1{
      line-height:var(--lh-h1-medium);
    }
  }

@media (min-width: 1280px){
    :host([site='GHS']) .hero-banner-title,
    :host([site='GHS']) .hero-banner-title h1{
      line-height:var(--lh-5xl);
    }
  }

:host([site='GHS']) .hero-banner-author {
      padding-bottom:0.75rem;
}

:host([site='GHS']) .hero-banner-author {
      font-family:var(--ff-body);
}

:host([site='GHS']) .hero-banner-location {
      padding-bottom:0.75rem;
}

:host([site='GHS']) .hero-banner-body-text {
      padding-bottom:0.75rem;
}

:host([site='GHS']) .hero-banner-body-text {
      max-width:64rem;
}

:host([site='GHS']) .hero-banner-body-text {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='GHS']) .hero-banner-body-text {
      font-weight:var(--fw-medium);
}

:host([site='GHS']) .hero-banner-date, :host([site='GHS']) .hero-banner-location, :host([site='GHS']) .hero-banner-phone-number {
      display:flex;
}

:host([site='GHS']) .hero-banner-date, :host([site='GHS']) .hero-banner-location, :host([site='GHS']) .hero-banner-phone-number {
      align-items:center;
}

:host([site='GHS']) .hero-banner-date, :host([site='GHS']) .hero-banner-location, :host([site='GHS']) .hero-banner-phone-number {
      padding-bottom:0.75rem;
}

:host([site='GHS']) .hero-banner-date ghs-icon, :host([site='GHS']) .hero-banner-location ghs-icon, :host([site='GHS']) .hero-banner-phone-number ghs-icon {
      margin-right:0.75rem;
}

:host([site='GHS']) .hero-banner-date, :host([site='GHS']) .hero-banner-location {
      font-family:var(--ff-display);
}

:host([site='GHS']) .hero-banner-date, :host([site='GHS']) .hero-banner-location {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='GHS']) .hero-banner-date, :host([site='GHS']) .hero-banner-location {
      font-weight:var(--fw-medium);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .hero-banner-date, :host([site='GHS']) .hero-banner-location {
            font-size:var(--fs-xl);
            line-height:var(--lh-xl);
      }
}

:host([site='GHS']) .hero-banner-phone-number {
      padding-bottom:0.75rem;
}

:host([site='GHS']) .hero-banner-phone-number {
      font-size:var(--fs-base);
      line-height:var(--lh-base);
}

:host([site='GHS']) .hero-banner-phone-number {
      font-weight:var(--fw-semibold);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .hero-banner-phone-number {
            font-size:var(--fs-lg);
            line-height:var(--lh-lg);
      }
}

:host([site='GHS']) .hero-banner-social-icons {
      padding-bottom:0.75rem;
}

:host([site='GHS']) .hero-banner-buttons {
      padding-top:0.75rem;
}

:host([site='GHS']) .hero-banner-buttons {
      padding-bottom:1.5rem;
}

:host([site='GHS']) .hero-banner-form-wrapper {
      margin-top:-1rem;
}

:host([site='GHS']) .hero-banner-form-wrapper {
      border-top-left-radius:0.75rem;
}

:host([site='GHS']) .hero-banner-form-wrapper {
      border-top-right-radius:0.75rem;
}

:host([site='GHS']) .hero-banner-form-wrapper {
      background-color:var(--neutral-white);
}

:host([site='GHS']) .hero-banner-form-wrapper {
      padding:1rem;
}

:host([site='GHS']) .hero-banner-form-wrapper {
      color:var(--neutral-black);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .hero-banner-form-wrapper {
            margin-top:-2rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .hero-banner-form-wrapper {
            padding-top:1.75rem;
            padding-bottom:1.75rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .hero-banner-form-wrapper {
            padding-left:3rem;
            padding-right:3rem;
      }
}

:host([site='GHS']) .hero-banner-form-wrapper.shadow-lg {
      border-radius:0.75rem;
}

:host([site='GHS']) .hero-banner-form-wrapper.shadow-lg{
      box-shadow:var(--brand-shadow);
    }

:host([site='GHS']) .hero-banner--details .hero-banner-background{
    min-height:400px;
  }

:host([site='GHS']) .hero-banner-details-wrapper {
      margin-bottom:1rem;
}

:host([site='GHS']) .hero-banner-details-wrapper{
    margin-top:-290px;
  }

:host([site='GHS']) .connect-cta .hero-banner-title, :host([site='GHS']) .connect-cta .hero-banner-title h1 {
      font-size:var(--fs-3xl);
      line-height:var(--lh-3xl);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .connect-cta .hero-banner-title, :host([site='GHS']) .connect-cta .hero-banner-title h1 {
            font-size:var(--fs-4xl);
            line-height:var(--lh-4xl);
      }
}

@media (min-width: 1280px) {

      :host([site='GHS']) .connect-cta .hero-banner-title, :host([site='GHS']) .connect-cta .hero-banner-title h1 {
            font-size:var(--fs-5xl);
            line-height:var(--lh-5xl);
      }
}

:host([site='GHS']) .connect-cta .hero-banner-body-text {
      font-family:var(--ff-body);
}

:host([site='GHS']) .connect-cta .hero-banner-body-text {
      font-weight:var(--fw-normal);
}

:host([site='GHS']) .hero-banner--hide-mobile-image .hero-banner-hero-image {
      display:none;
}

@media (min-width: 768px) {

      :host([site='GHS']) .hero-banner--hide-mobile-image .hero-banner-hero-image {
            display:block;
      }
}
`;